import {
  ComponentHelper,
  FormBaseComponent,
  MappedStammdatenGesetzlicherVertreter,
  StammdatenService,
  ValidationPattern,
  ValidatorService
} from '@utils-lib';
import {TranslateService} from '@ngx-translate/core';
import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {AppNameEnum, GesetzlicherVertreter} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';
import {cloneDeep} from 'lodash';

@Component({
  selector: 'common-ui-gesetzlicher-vertreter-form',
  templateUrl: './gesetzlicher-vertreter-form.component.html'
})
export class GesetzlicherVertreterFormComponent extends FormBaseComponent<GesetzlicherVertreter> implements OnInit, AfterViewInit {

  @Input()
  public stammdaten: MappedStammdatenGesetzlicherVertreter;
  @Input()
  public gesetzlicherVertreter: GesetzlicherVertreter;
  public isKapGAus = false;

  constructor(private readonly formBuilder: FormBuilder,
              protected readonly messageService: DatevMessageService,
              private readonly currentRoute: ActivatedRoute,
              private readonly stammdatenService: StammdatenService,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService) {
    super(messageService);
  }

  ngOnInit(): void {
    if (this.gesetzlicherVertreter.stammdatenIndex !== undefined) {
      const stammdatenWithIndex = cloneDeep(
        this.currentRoute.snapshot.data.stammdaten.gesetzlicherVertreter[this.gesetzlicherVertreter.stammdatenIndex]
      );
      this.stammdaten = stammdatenWithIndex.value;
    }
    this.data = this.gesetzlicherVertreter;
    const appEnum = ComponentHelper.getAppEnum(this.currentRoute.snapshot);
    if (appEnum === AppNameEnum.FragebogenKapGAus) {
      this.isKapGAus = true;
    } else {
      this.data.ustIdentifikationsnummer = null;
    }
    super.ngOnInit();
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      ustIdentifikationsnummer: [this.data.ustIdentifikationsnummer, [
        this.validatorService.pattern(ValidationPattern.UST_ID,
          this.translateService.instant('COMMON_UI.VALIDATION.USTID_PATTERN'))
      ]]
    });
    if (this.data.inlandsadresse === undefined
      && this.data.auslandsadresse === undefined
      && this.data.kommunikationsmittel === undefined) {
      this.stammdatenService.assignStammdatenIfDeterministic(this.getStammdatenMappingRules(), this.data);
    }
  }

  protected getStammdatenMappingRules(): Map<string, unknown> {
    return new Map<string, unknown | Array<unknown>>([
      ['inlandsadresse', this.stammdaten?.inlandsadressen],
      ['auslandsadresse', this.stammdaten?.auslandsadressen],
      ['postfachadresse', this.stammdaten?.postfachadressen],
      ['kommunikationsmittel.telefonnummern[0]', this.stammdaten?.kommunikation?.telefonnummern],
      ['kommunikationsmittel.internet', this.stammdaten?.kommunikation?.internetadressen]
    ]);
  }

}
